import script from "./QueueUpsellPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueUpsellPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueueUpsellPage.vue?vue&type=style&index=0&id=1f4070de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4070de"]])

export default __exports__